import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useStyledBlock, StyleControls, AdvancedStyleControls } from "./StyleControls";
import { MediaPickerField } from "./MediaPickerField";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";
import type { ResponsiveStyleProps } from "@/lib/craft/style-props";

type ImageProps = {
  src: string;
  alt: string;
  mediaId?: string | null;
  objectFit?: "cover" | "contain" | "fill";
  style?: ResponsiveStyleProps;
};

export function ImageBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<ImageProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <MediaPickerField
          value={{
            mediaId: props.mediaId ?? null,
            url: props.src || null,
            altText: props.alt || null,
          }}
          onChange={(sel) =>
            setProp((p) => {
              p.mediaId = sel.mediaId;
              p.src = sel.url ?? "";
              if (sel.altText) p.alt = sel.altText;
            })
          }
        />
        <div className="space-y-1">
          <Label className="text-xs">Alt text</Label>
          <Input
            className="h-8 text-xs"
            value={props.alt ?? ""}
            onChange={(e) => setProp((p) => { p.alt = e.target.value; })}
          />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Object fit</Label>
          <Select
            value={props.objectFit ?? "cover"}
            onValueChange={(v) => setProp((p) => { p.objectFit = v as ImageProps["objectFit"]; })}
          >
            <SelectTrigger className="h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="cover">Cover</SelectItem>
              <SelectItem value="contain">Contain</SelectItem>
              <SelectItem value="fill">Fill</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    );
  }
  if (tab === "style") {
    return (
      <StyleControls
        style={style}
        updateStyle={updateStyle}
        breakpoint={breakpoint}
        showBorderRadius
        showBackground={false}
      />
    );
  }
  return <AdvancedStyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
}
